<template>
    <div class="row">
        <div class="
        col-lg-4 offset-lg-8
        col-md-6 offset-md-6
        col-sm-12 offset-sm-0
        col-xs-12 offset-xs-0">
            <div class="d-flex flex-row-reverse align-items-center">
                <b-button variant="primary" class="text-capitalize ml-5" @click="ProxySaveLetter">simpan</b-button>
                <b-button variant="success" class="text-capitalize ml-5" @click="ProxyPrintLetter">cetak</b-button>
                <b-button variant="danger" class="text-capitalize" @click="ResetSuratPenunjangStore">batal</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'SuratPenunjangFormsBaseFooter',
    methods: {
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        ProxyPrintLetter() {
            this.$emit('PrintLetter');
        },
        ProxySaveLetter() {
            this.$emit('SaveLetter');
        }
    }
}
</script>

<style></style>